<template>
	<div class="order-info">
		<p class="o-title">{{orderTitle}}</p>
        <div class="o-order">
            <p class="o-order-p">
              <span class="title">订单编号</span>
              <span class="text">{{privateData.orderInfo.orderNum}}</span>
            </p>
            <p class="o-order-p">
              <span class="title">下单时间</span>
              <span class="text">{{privateData.orderInfo.createTime}}</span>
            </p>
            <p class="o-order-p">
              <span class="title">支付方式</span>
              <span class="text">{{privateData.orderInfo.payTypeName ? privateData.orderInfo.payTypeName : '无'}}</span>
            </p>
            <p class="o-order-p">
              <span class="title">支付状态</span>
              <span class="text">{{privateData.orderInfo.statusDesc}}</span>
            </p>
        </div>
	</div>
</template>
<script>
export default {
	data () {
		return {
			privateData: {}
		}
	},
	props: ['detailData', 'orderTitle'],
	created () {
		// 处理预购卡和其它订单接口字段不一样
		this.privateData = JSON.parse(JSON.stringify(this.detailData))
	}
}
</script>
<style lang="less" scoped>
	.order-info{
		.o-title{
	      	font-weight: bolder;
	      	padding-bottom: 10px;
	    }
	    .o-order,
	    .o-detail, 
	    .o-address{
			color: #666;
	      margin-bottom: 20px;
	      .title{
	        min-width: 90px;
	        display: inline-block;
	        padding: 15px 20px;
	        border-right: solid 1px #E0E0E0;
	      }
	      .text{
	        display: inline-block;
	        padding: 15px 20px;
	        color: #333333;
	        max-width: 820px;
	        white-space: nowrap;
	        overflow: hidden;
	        text-overflow: ellipsis;
	        vertical-align: bottom;
	      }
	      .pre-sell-text {
	        border-right: none;
	        border-left: solid 1px #E0E0E0;
	        p {
	          color: #666;
	          font-size: 12px;
	          line-height: 14px;
	          padding: 0;
	          & + p {
	            margin-top: 9px;
	          }
	        }
	      }
	      .oprate{
	        cursor: pointer;
	        color: #f13232;
	      }
	      .border-bottom{
	        border-bottom: solid 1px #E0E0E0;
	      }
	    }
	    .o-order{
	      &:after{
	        content: '';
	        display: block;
	        clear: both;
	        visibility:hidden;
	        height:0;
	      }
	      .o-order-p{
	        width: 50%;
	        float: left;
	        border: solid 1px #E0E0E0;
	        &:nth-child(even){
	          border-left: none;
	        }
	        &:nth-last-child(2), &:last-child{
	          border-top: none;
	        }
	      }
	    }
	}
</style>


// WEBPACK FOOTER //
// module/order/src/components/sub/orderInfo.vue